import { render, staticRenderFns } from "./copy.vue?vue&type=template&id=e9ccd452&scoped=true"
import script from "./copy.vue?vue&type=script&lang=js"
export * from "./copy.vue?vue&type=script&lang=js"
import style0 from "./copy.vue?vue&type=style&index=0&id=e9ccd452&prod&lang=scss&scoped=true"
import style1 from "./copy.vue?vue&type=style&index=1&id=e9ccd452&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ccd452",
  null
  
)

export default component.exports